import * as types from './actionTypes';

export function receivePromoCode(promoCode) {
	return { type: types.RECEIVE_PROMO_CODE, promoCode: promoCode };
}
